<template>
    <label class="label">
        {{ label }}
        <span class="label__required" v-if="required">*</span>
        <span class="label__info" v-if="description != ''" v-html="description"></span>
    </label>
</template>

<script>
    export default {
        name: 'app-label',
        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
        }
    }
</script>

<style lang="scss">
    .label {
        @apply .block .mb-2 .text-left .text-black .text-xs .font-bold;

        &.reset {
            @apply .mb-0;
        }
	}
</style>



// WEBPACK FOOTER //
// src/components/fields/Label.vue